import useSessionStore from '../stores/useSessionStore';
import useShellStore from '../stores/useShellStore';
import useWorkspaceStore from '../stores/useWorkspaceStore';


export const appBackendApi = new Proxy(
  {},
  {
    get(_target, prop) {
      if (prop === 'user') {
        return useSessionStore.getState().user;
      }
      if (prop === 'collapsed') {
        return useShellStore.getState().collapsed;
      }
      if (prop === 'currentPage') {
        return useShellStore.getState().currentPage;
      }
      return useWorkspaceStore.getState()[prop];
    },
  },
);
